
import _ from 'lodash';

const namespaced = true;

const state = {
  tags: [],
};

const mutations = {
  SET_TAGS(state, tags) {
    state.tags = tags;
  },
  ADD_TAG_TO_LIST(state, tag) {
    state.tags.push(tag);
  },
  UPDATE_TAG(state, tag) {
    const tagIndex = _.findIndex(state.tags, { id: tag.id });
    if (tagIndex !== -1) {
      state.tags[tagIndex] = tag;
      state.tags = _.clone(state.tags);
    }
  },
};

const actions = {
  async fetchMakerTags({ rootState, commit, dispatch }) {
    commit(`SET_TAGS`, []);
    const makerId = rootState[`model/client`].company.id;
    const tags = await dispatch(`model/tag/fetchForMaker`, makerId, { root: true });

    commit(`SET_TAGS`, tags);
    return tags;
  },
  async fetchClientTags({ rootState, commit, dispatch }) {
    commit(`SET_TAGS`, []);
    const clientId = rootState[`model/client`].company.id;
    const tags = await dispatch(`model/tag/fetchForClient`, clientId, { root: true });

    commit(`SET_TAGS`, tags);
    return tags;
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
